import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";

const OverviewSection = lazy(() => import("./OverviewSection"));
const ContentSection = lazy(() => import("./ContentSection"));
const BenefitSection = lazy(() => import("./BenefitSection"));
const FeatureSection = lazy(() => import("./FeatureSection"));

const ThirdPartyIntegration = () => {
  return (
    <>
      <Helmet>
        <title>
          Expert Software Consulting Services | Accelerate Digital
          Transformation
        </title>
        <meta
          name="description"
          content="Boost your business growth with expert software consulting. Our senior consultants provide strategic guidance, optimized systems, and flexible solutions for smarter decision-making and accelerated digital transformation."
        />
        <meta
          name="keywords"
          content="IT strategy consulting, technology consulting, business technology solutions, software project management, software optimization, IT consulting experts, strategic software solutions"
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <OverviewSection />
        <ContentSection />
        <BenefitSection />
        <FeatureSection />
      </Suspense>
    </>
  );
};

export default ThirdPartyIntegration;
